// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customClass {
    white-space: nowrap
  }

  .filterComponentHeight{
    margin-top: -5%;
  }

  .textHeight1{
    margin-top: -1%;
  }

  .addProviderText{
    margin-left: 1337px !important;
    white-space: nowrap;
  }`, "",{"version":3,"sources":["webpack://./resources/components/public/provider/customBottomTab.css"],"names":[],"mappings":"AAAA;IACI;EACF;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB","sourcesContent":[".customClass {\n    white-space: nowrap\n  }\n\n  .filterComponentHeight{\n    margin-top: -5%;\n  }\n\n  .textHeight1{\n    margin-top: -1%;\n  }\n\n  .addProviderText{\n    margin-left: 1337px !important;\n    white-space: nowrap;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
